fluid-grid {
  flex: 1 1 auto; // Relevant when parent container uses flexbox layout
  display: flex;
  flex-wrap: wrap;
  box-sizing: border-box;

  *,
  *::after,
  *::before {
    box-sizing: border-box;
  }

  // ==== 100% Height Grid ("fullHeight" Prop)

  &.full-height {
    height: 100%;
  }

  // ==== Inline Grid ("inline" Prop)

  &.inline-flex {
    display: inline-flex;
  }

  // ==== Grid Item Spacing ("gridItemSpacing" Prop)

  .create-grid-item-spacing();

  // == No Grid Item Spacing ("removeSpacing" Prop)

  &.no-spacing {
    margin: 0 0 0 0;

    & > fluid-grid-item {
      padding: 0 0 0 0;
    }
  }

  // == Empty Grid

  &:empty {
    margin: 0; // Remove default negative margin if no children exist
  }

  // ==== Grid Justifications

  .create-flex-justifications();

  // ==== Grid Vertical Alignments

  .create-flex-alignments();

  // ==== Grid Directions

  .create-flex-directions();
}


// ================================================================ //
// -- Mixins

/**
 * Creates a CSS class for each type of flexbox justification
 */
.create-flex-justifications() {
  @flex-justifications: {
    start: flex-start;
    center: center;
    end: flex-end;
    around: space-around;
    between: space-between;
  }

  each(@flex-justifications, {
    &.justify-@{key} {
      justify-content: @value;
    }
  });
}

/**
 * Creates a CSS class for each type of flexbox vertical alignment
 */
.create-flex-alignments() {
  @flex-alignments: {
    start: flex-start;
    center: center;
    end: flex-end;
    stretch: stretch;
    baseline: baseline;
  }

  each(@flex-alignments, {
    &.align-@{key} {
      align-items: @value;
    }
  });
}

/**
 * Creates a CSS class for each type of flexbox direction
 */
.create-flex-directions() {
  @flex-directions: {
    row: row;
    row-reverse: row-reverse;
    column: column;
    column-reverse: column-reverse;
  }

  each(@flex-directions, {
    &.direction-@{key} {
      flex-direction: @value;
    }
  })
}

/**
 * Creates a CSS class for each spacing increment
 */
.create-grid-item-spacing() {
  @spacing-values: {
    xxs: 8px;
    xs: 16px;
    sm: 24px;
    md: 32px;
    lg: 48px;
    xl: 64px;
  }

  each(@spacing-values, {
    @size: @value / 2; // Divide by 2, since padding is applied to each Grid Item

    &.spacing-@{key} {
      margin-left: -@size;
      margin-right: -@size;
      margin-top: -@size;
      margin-bottom: -@size;

      & > fluid-grid-item {
        padding-left: @size;
        padding-right: @size;
        padding-top: @size;
        padding-bottom: @size;
      }
    }
  });
}
